/* oxlint-disable unicorn/prevent-abbreviations */
// @ts-check
// This is a .mjs file, so that it can be imported into
// environment.mjs, which can be imported into next.config.mjs to get build
// time environment variable validation.
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import { createEnv } from '@t3-oss/env-nextjs'
import { z } from 'zod'

const trimmedString = () => z.string().trim()

const urlOrIPSchema = z.union([z.string().url(), z.string().ip()]).refine(
  (value) => !value.endsWith('/'),
  (value) => ({ message: `${value} has trailing slashes` }),
)

/**
 * Zod coerce.boolean acts simply. It pipes the value throught the Boolean() constructor, so "false" will be true.
 * We should allow to use "0", "false" as falsy and "1", "true" as truthy values!
 */
const booleanEnvironmentSchema = z
  .enum(['0', '1', 'true', 'false', ''])
  .transform((value) => value === 'true' || value === '1')
  .default('false')
  .or(z.boolean().default(false))
  .or(z.number().transform((value) => value === 1))

/**
 * client-side variable object with zod schema
 */
const client = {
  NEXT_PUBLIC_BASE_URL: trimmedString().url(),
  NEXT_PUBLIC_API_BASE_URL: trimmedString().url(),

  NEXT_PUBLIC_ENV: z.enum(['development', 'preview', 'production']).optional(),

  // Segment
  NEXT_PUBLIC_SEGMENT_WRITE_KEY: trimmedString(),

  NEXT_PUBLIC_LAUNCHDARKLY_SDK_CLIENT_SIDE_ID: trimmedString().optional(),

  // Vercel mirroring
  NEXT_PUBLIC_VERCEL_BRANCH_URL: trimmedString(),
  NEXT_PUBLIC_VERCEL_ENV: trimmedString(),

  // Feature flags
  NEXT_PUBLIC_ENABLE_LOGISTICS: booleanEnvironmentSchema,
  NEXT_PUBLIC_ENABLE_TAKE_OVER_WAREHOUSE_SHIPMENTS: booleanEnvironmentSchema,

  // Storyblok
  NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN: trimmedString(),
}

/**
 * server-side variable object with zod schema
 */
const server = {
  NODE_ENV: z.enum(['development', 'test', 'preview', 'production']),

  CI: booleanEnvironmentSchema,

  // Vercel
  VERCEL_ENV: z.enum(['development', 'preview', 'production']),
  VERCEL_GIT_COMMIT_SHA: z.string(),

  // Playwright
  PLAYWRIGHT_API_BASE_URL: urlOrIPSchema,
  E2E_BASE_URL: urlOrIPSchema.optional(),

  // Private feature flags
  NEXT_FEATURE_ENABLE_PROFORMA_UPLOAD: booleanEnvironmentSchema,
}

/**
 * Environment object with manual declaration of runtime variables
 * (can't be destructured on the fly because of the way Next.js works)
 */
// Ignoring Prettier to not wrap the code to multiple lines so it's easier to read
// prettier-ignore
export const env = createEnv({
  client,
  server,
  runtimeEnv: {
    NODE_ENV: process.env.NODE_ENV,
    E2E_BASE_URL: process.env.E2E_BASE_URL,
    CI: process.env.CI,
    NEXT_PUBLIC_API_BASE_URL: process.env.NEXT_PUBLIC_API_BASE_URL,
    VERCEL_ENV: process.env.VERCEL_ENV,
    PLAYWRIGHT_API_BASE_URL: process.env.PLAYWRIGHT_API_BASE_URL,
    NEXT_FEATURE_ENABLE_PROFORMA_UPLOAD: process.env.NEXT_FEATURE_ENABLE_PROFORMA_UPLOAD,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_ENABLE_LOGISTICS: process.env.NEXT_PUBLIC_ENABLE_LOGISTICS,
    NEXT_PUBLIC_ENV: process.env.NEXT_PUBLIC_ENV,
    NEXT_PUBLIC_SEGMENT_WRITE_KEY: process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY,
    VERCEL_GIT_COMMIT_SHA: process.env.VERCEL_GIT_COMMIT_SHA,
    NEXT_PUBLIC_ENABLE_TAKE_OVER_WAREHOUSE_SHIPMENTS: process.env.NEXT_PUBLIC_ENABLE_TAKE_OVER_WAREHOUSE_SHIPMENTS,
    NEXT_PUBLIC_LAUNCHDARKLY_SDK_CLIENT_SIDE_ID: process.env.NEXT_PUBLIC_LAUNCHDARKLY_SDK_CLIENT_SIDE_ID,
    NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN: process.env.NEXT_PUBLIC_STORYBLOK_ACCESS_TOKEN,
    // Vercel mirroring
    NEXT_PUBLIC_VERCEL_BRANCH_URL: process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL,
    NEXT_PUBLIC_VERCEL_ENV: process.env.NEXT_PUBLIC_VERCEL_ENV,
  },
})
